<template>
    <section class="dashboard-details" :class="{'library-open': !uiStates.editDisabled}">
        <alerts :status="alert" v-model="alert"></alerts>
        <master-loader :is-loaded="uiStates.showLoading"></master-loader>
        <div v-if="hasFullScreenNotification" class="text-center container">
            <div v-if="nextFullscreenNotification.type === 'fullscreen-component'">
                <component :is="nextFullscreenNotification.copy" :notification="nextFullscreenNotification" @dismiss="dismissSingleNotification"></component>
            </div>
            <div v-else>
                <span v-html="nextFullscreenNotification.copy"></span>
                <button v-if="nextFullscreenNotification.dismissLabel" type="button" class="btn btn-primary" @click="dismissSingleNotification(nextFullscreenNotification)">{{nextFullscreenNotification.dismissLabel}}</button>
            </div>
        </div>
        <div v-else>
            <dashboard-notifications v-if="uiStates.showNotifications"
                @dismissAll="dismissNotifications"
                @dismissSingle="dismissSingleNotification"
                :notifications="notifications"></dashboard-notifications>
            <dashboard-heading
                :dashboards="dashboards"
                :is-notifications-visible="uiStates.showNotifications"
                :notification="notifications">
            </dashboard-heading>
            <dashboard-widgets @widgetConfigured="addChannelId"
                :create-mode="dashboardCreateMode"
                :active-dashboard="dashboards.active"
                :edit-disabled="uiStates.editDisabled">
            </dashboard-widgets>
            <dashboard-library v-if="!uiStates.editDisabled" :edit-disabled="uiStates.editDisabled"></dashboard-library>
            <dashboard-activity-view v-if="uiStates.activityView"></dashboard-activity-view>
        </div>
        <div class="dashboard-bg"></div>
    </section>
</template>

<script type="text/javascript">

    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import moment from 'moment';

    import MasterLoader from './dashboard-master-loader.vue';
    import DashboardHeading from './dashboard-heading.vue';
    import DashboardNotifications from './dashboard-notifications.vue';
    import DashboardWidgets from './dashboard-widgets.vue';
    import DashboardLibrary from './dashboard-library.vue';
    import DashboardActivityView from './dashboard-activity-view.vue';

    import ProductAlerts from "../products/product-details-alerts.vue";

    import ShopifyWarmWelcome from '../notification/shopify-warm-welcome.vue';

    Vue.use(VueEvents)

    export default {
        name: 'dashboard-details',
        props: ['userId', 'alertMessage'],
        components:{
            DashboardHeading,
            DashboardNotifications,
            DashboardWidgets,
            DashboardLibrary,
            DashboardActivityView,
            MasterLoader,
            ShopifyWarmWelcome,
            alerts: ProductAlerts,
        },
        data() {
            return {
                currentUserId: this.userId,
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                uiStates: {
                    showLoading: true,
                    showNotifications: false,
                    activityView: false,
                    editDisabled: true,
                    allowEdit:true,
                },
                dashboardCreateMode: false,
                dashboards: {
                    active: {
                        title: null,
                        id: null,
                        widgets: [],
                    },
                    usersDashboards: [],
                },
                tempDashboard: {
                    name: '',
                    id: 0,
                    widgets: [],
                },
                notifications: [],
                loadedWidgets: [],
                allWidgets: [],
            }
        },
        mounted() {
            this.loadDashboardListing();
            this.loadUserNotifications();

            if (this.alertMessage !== "") {
                this.showAlert(this.alertMessage);
            }
        },
        computed: {
            hasFullScreenNotification() {
                return (this.fullscreenNotifications.length > 0 ? true: false);
            },
            nextFullscreenNotification() {
                if (this.hasFullScreenNotification) {
                    return this.fullscreenNotifications[0];
                }
                return [];
            },
            fullscreenNotifications() {
                return this.notifications.filter (el => {
                    if (el.type == 'fullscreen' || el.type == 'fullscreen-component') {
                        if (el.hasOwnProperty('dismissed')) {
                            return !el.dismissed;
                        } else {
                            this.$set(el, 'dismissed', false);
                        }
                        return true;
                    }
                });
            }
        },
        methods: {
            addChannelId: function(widget) {
                // let index = this.dashboards.active.widgets.findIndex(x => x.title === widget.title);
                // this.dashboards.active.widgets[index]['configuration'] = {};
                // this.dashboards.active.widgets[index]['configuration'].channelId = channelId;
            },
            dismissNotifications: function() {
                axios.get(base_url+'/pimapi/notifications/dismiss', {

                })
                .then(function(response) {
                    this.$parent.toggleNotifications()
                    this.notifications.splice(0, this.notifications.length);
                }.bind(this))
                .catch(function(error) {
                }.bind(this));
            },
            dismissSingleNotification: function(notificationItem) {
                axios.get(base_url+'/pimapi/notifications/'+notificationItem.id+'/dismiss', {

                })
                .then(function(response) {
                    this.notifications.splice(this.notifications.findIndex(({id}) => id == notificationItem.id), 1);
                }.bind(this))
                .catch(function(error) {
                }.bind(this));
            },
            toggleNotifications: function(){
                this.uiStates.showNotifications = !this.uiStates.showNotifications;
            },
            loadUserNotifications:function() {
                axios.get(base_url+'/pimapi/notifications', {

                })
                .then(function(response) {
                    response.data.notifications.forEach((element, idx) => {
                        this.$set(this.notifications, idx, element);
                        this.$set(this.notifications[idx], 'dismissed', false);
                    });
                }.bind(this))
                .catch(function(error) {
                }.bind(this));
            },
            loadDashboardListing: function() {
                axios.get(base_url+'/pimapi/dashboards', {

                })
                .then(function(response) {
                    this.dashboards.usersDashboards = response.data.dashboards;
                    this.dashboards.active = response.data.dashboards[0];
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function(error) {
                    this.uiStates.showLoading = false;
                }.bind(this));
            },
            loadDashboardListingById: function(id) {
                axios.get(base_url+'/pimapi/dashboards/'+id, {

                })
                .then(function(response) {
                    this.dashboards.usersDashboards = response.data.dashboards;
                    this.dashboards.active = response.data.dashboards[0];
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function(error) {
                    this.uiStates.showLoading = false;
                }.bind(this));
            },
            createDashboard: function(){
                this.uiStates.showLoading = true;
                var currentDashboard = this.dashboards.active;
                axios.post(base_url+'/pimapi/dashboards', {
                    'currentDashboard': currentDashboard
                })
                .then(function(response) {
                    this.uiStates.editDisabled = true;
                    this.dashboardCreateMode = false;
                    this.tempDashboard.name = null;
                    this.tempDashboard.widgets = [];
                    this.dashboards.usersDashboards = response.data.dashboards;
                    this.dashboards.active = response.data.dashboards[0];
                    setTimeout(function(){
                        this.uiStates.showLoading = false;
                    }.bind(this), 2000);
                }.bind(this))
                .catch(function(error) {
                    this.uiStates.showLoading = false;
                }.bind(this));
            },
            deleteDashboard: function(dashboardID){
                this.uiStates.showLoading = true;
                axios.delete(base_url+'/pimapi/dashboards/'+dashboardID)
                .then(function(response) {
                    this.loadDashboardListing();
                }.bind(this))
                .catch(function(error) {

                }.bind(this));
            },
            createCancel: function(dashboardID){
                this.uiStates.showLoading = true;
                this.dashboards.active = this.dashboards.usersDashboards[0];
                this.uiStates.editDisabled = true;
                this.dashboardCreateMode = false;
                this.tempDashboard.name = null;
                this.tempDashboard.widgets = [];

                setTimeout(function(){
                    this.uiStates.showLoading = false;
                }.bind(this), 2000);
            },
            showAlert: function(msg) {
                this.alert.status = 'alert-warning';
                this.alert.message = msg;
            },
        },
    };
</script>

<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to{
        opacity: 0;
    }
    .dashboard-details{
        min-height:calc(100vh - 145px);
        position: relative;
        transition: margin-bottom 0.2s linear;

        &.library-open{
            transition: margin-bottom 0.2s linear;
            margin-bottom: 400px;
        }
    }
    .dashboard-bg{
        position: absolute;
        opacity: 0.2;
        background:transparent url('/images/bg-dashboard.png') center bottom no-repeat;
        background-size: 100% auto;
        z-index: -1;
        left: -31px;
        right: -31px;
        bottom: -30px;
        height: 100vh;
    }
</style>
